"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PowerItemsShopBtn;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PowerItemsShopBtnModule = _interopRequireDefault(require("./PowerItemsShopBtn.module.scss"));

var _Button = _interopRequireDefault(require("../../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../../inputElements/Button/EButtonType"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PowerItemsShopBtn(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_PowerItemsShopBtnModule.default.button, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.POWER_ITEM_SHOP
  }));
}